// wait for StayAi to load first
document.addEventListener('DOMContentLoaded', () => {
  const stayaiPlanPicker = document.querySelector('#stayai-plan-picker');

  if (!stayaiPlanPicker) return;

  const stayaiInput = stayaiPlanPicker.querySelector(
    '#purchaseTypeSubscription'
  );

  if (!stayaiInput) return;

  const clubCtaBtns = document.querySelectorAll(
    'a[href="#stayai-plan-picker"]'
  );

  clubCtaBtns.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      stayaiPlanPicker.scrollIntoView({ behavior: 'smooth' });
      stayaiInput.click();
    });
  });
});
